import { FeatureFlags } from "@utils/FeatureFlags/generated-flags.ts";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Navigate } from "react-router-dom";
import { roleType } from "src/layouts/config";

import { Authorize } from "@components/Authorize/Authorize.tsx";
import { AdminAnalytics } from "@pages/AdminAnalytics/AdminAnalytics.tsx";
import { AdminAnalyticsProvider } from "@pages/AdminAnalytics/AdminAnalyticsProvider.tsx";
import { useGraphqlAdminAnalyticsAdapter } from "@pages/AdminAnalytics/data/graphqlAdapter";

interface AdminAnalyticsRouteProps {
  allowedRoles: roleType[];
}

export const AdminAnalyticsRoute: React.FC<AdminAnalyticsRouteProps> = ({ allowedRoles }) => {
  const flags = useFlags<FeatureFlags>();
  const adapter = useGraphqlAdminAnalyticsAdapter();
  if (!flags["portal-admin-analytics"]) return <Navigate to="/" replace />;
  return (
    <Authorize allowedRoles={allowedRoles}>
      <AdminAnalyticsProvider adapter={adapter}>
        <AdminAnalytics />
      </AdminAnalyticsProvider>
    </Authorize>
  );
};
